module.exports = __webpack_public_path__ + "img/icon_MyAchievement.a31c253f.svg";